import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { sizePerPageList } from "../../../../../config/helper";
import { getOrgTotalDonation } from "../../../_redux/dashboard/dashboardCrud";

export default function OrgTotalDonation() {
  const [queryParams, setQueryParams] = useState({
    pageNumber: 1,
    pageSize: 10
  });

  const [dataTable, setDataTable] = useState({
    loading: false,
    rows: [],
    totalCount: 0
  });

  useEffect(() => {
    fetchData();
  }, [queryParams]);

  async function fetchData() {
    setDataTable(prev => ({
      ...prev,
      loading: true
    }));
    const {
      data: { data }
    } = await getOrgTotalDonation(queryParams);
    setDataTable(prev => ({
      ...prev,
      loading: false,
      rows: data.items,
      totalCount: +data.total_items
    }));
  }

  const columns = [
    {
      dataField: "name",
      text: "Lembaga"
    },
    {
      dataField: "total_donation",
      text: "Total penerima donasi"
    }
  ];

  const paginationOptions = {
    custom: true,
    totalSize: dataTable.totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <div className={`card card-custom overflow-auto`} style={{height: '450px'}}>
        <div className={`card-body text-center`}>
          <div className="d-flex justify-content-center align-content-center">
            <div className="align-self-center">
              <p className="text-hover-primary text-center font-weight-bold font-size-h6">
                Total Penerimaan Donasi Lembaga
              </p>
              <div className="overflow-auto">
                <PaginationProvider
                  pagination={paginationFactory(paginationOptions)}
                >
                  {({ paginationProps, paginationTableProps }) => {
                    return (
                      <Pagination
                        isLoading={dataTable.loading}
                        paginationProps={paginationProps}
                      >
                        <BootstrapTable
                          rowStyle={{fontSize: '10px'}}
                          wrapperClasses="table-responsive"
                          classes="table table-head-custom-font-size table-vertical-center overflow-hidden"
                          bootstrap4
                          bordered={false}
                          remote
                          keyField="uuid"
                          data={dataTable.rows}
                          columns={columns}
                          // defaultSorted={uiHelpers.defaultSorted}
                          onTableChange={getHandlerTableChange(setQueryParams)}
                          {...paginationTableProps}
                        >
                          <PleaseWaitMessage entities={dataTable.rows} />
                          <NoRecordsFoundMessage entities={dataTable.rows} />
                        </BootstrapTable>
                      </Pagination>
                    );
                  }}
                </PaginationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <Card>
      <Card.Header>
        <h4>Total penerimaan donasi lembaga</h4>
      </Card.Header>
      <Card.Body>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <Pagination
                isLoading={dataTable.loading}
                paginationProps={paginationProps}
              >
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  bordered={false}
                  remote
                  keyField="uuid"
                  data={dataTable.rows}
                  columns={columns}
                  // defaultSorted={uiHelpers.defaultSorted}
                  onTableChange={getHandlerTableChange(setQueryParams)}
                  {...paginationTableProps}
                >
                  <PleaseWaitMessage entities={dataTable.rows} />
                  <NoRecordsFoundMessage entities={dataTable.rows} />
                </BootstrapTable>
              </Pagination>
            );
          }}
        </PaginationProvider>
      </Card.Body>
    </Card>
  );
}
